<template>
  <v-container
    fluid
    :class="['dashboard-container pa-4 pa-sm-6', isDarkMode ? 'dark-mode' : '']"
    id="create"
  >
    <v-card
      class="mb-6 rounded-lg dashboard-header elevation-1"
      :dark="isDarkMode"
      :class="{ 'card-light': !isDarkMode, 'card-dark': isDarkMode }"
    >
      <v-card-text class="py-6 px-6">
        <div class="d-flex flex-wrap justify-space-between align-center">
          <!-- Logo e Título -->
          <div class="dashboard-title d-flex align-center">
            <h1
              :class="isDarkMode ? 'white--text' : 'primary--text'"
              class="font-weight-medium"
            >
              Dashboard AiConsumer
            </h1>
            <v-btn
              icon
              @click="toggleDarkMode"
              :color="isDarkMode ? 'amber lighten-2' : 'grey darken-3'"
              class="ml-2"
              x-small
              fab
              elevation="1"
            >
              <v-icon>{{
                isDarkMode ? "mdi-white-balance-sunny" : "mdi-weather-night"
              }}</v-icon>
            </v-btn>
          </div>

          <!-- Filtros e Seletor -->
          <div class="d-flex align-center flex-nowrap">
            <v-menu
              v-model="menuFiltros"
              :close-on-content-click="false"
              offset-y
              rounded="lg"
              left
              transition="slide-y-transition"
              max-width="320"
            >
              <template v-slot:activator="{ on }">
                <div class="d-flex align-center">
                  <v-btn
                    class="mr-2 filter-btn"
                    small
                    depressed
                    :outlined="!filtroAtivo"
                    :color="filtroAtivo ? 'primary' : ''"
                    v-on="on"
                    @click="mostrarFiltros = !mostrarFiltros"
                    :class="{ 'btn-active': filtroAtivo }"
                    rounded
                  >
                    <v-icon left small>mdi-filter-outline</v-icon>
                    Filtrar
                  </v-btn>

                  <div
                    v-if="filtroAtivo"
                    class="d-flex align-center filter-tags"
                  >
                    <v-chip
                      small
                      outlined
                      color="primary"
                      class="mx-1 filter-chip"
                    >
                      <span class="caption"
                        >{{ dateFormattedInicio }} -
                        {{ dateFormattedFim }}</span
                      >
                    </v-chip>

                    <v-btn
                      icon
                      x-small
                      @click="limparFiltro"
                      color="grey"
                      class="ml-1"
                    >
                      <v-icon small>mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>

              <v-card class="pa-4 filter-menu" elevation="4">
                <v-card-title class="px-0 pt-0 subtitle-1">
                  Filtrar por período
                </v-card-title>
                <v-card-text class="px-0 pb-0">
                  <div class="mb-4">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormattedInicio"
                          label="Data Início"
                          prepend-inner-icon="mdi-calendar-start"
                          readonly
                          v-on="on"
                          outlined
                          dense
                          class="rounded-lg"
                          hide-details
                          v-mask="'##/##/####'"
                          :dark="isDarkMode"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataInicio"
                        @input="menu1 = false"
                        locale="pt-br"
                        color="primary"
                        :dark="isDarkMode"
                      ></v-date-picker>
                    </v-menu>
                  </div>

                  <div class="mb-4">
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormattedFim"
                          label="Data Fim"
                          prepend-inner-icon="mdi-calendar-end"
                          readonly
                          v-on="on"
                          outlined
                          dense
                          class="rounded-lg"
                          hide-details
                          v-mask="'##/##/####'"
                          :dark="isDarkMode"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataFim"
                        @input="menu2 = false"
                        locale="pt-br"
                        color="primary"
                        :dark="isDarkMode"
                      ></v-date-picker>
                    </v-menu>
                  </div>

                  <div class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      @click="
                        aplicarFiltro();
                        menuFiltros = false;
                      "
                      class="px-4"
                      depressed
                      small
                    >
                      <v-icon left size="18">mdi-magnify</v-icon>
                      Buscar
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>

            <v-select
              v-if="user.tipo == 'ADMIN'"
              outlined
              dense
              v-model="empresaSelecionada"
              :items="empresas"
              item-text="nome"
              item-value="id"
              label="Selecione a empresa"
              @input="carregaDados(empresaSelecionada)"
              hide-details
              prepend-inner-icon="mdi-office-building"
              class="rounded-lg empresa-select"
              :dark="isDarkMode"
              style="max-width: 250px"
              append-icon="mdi-chevron-down"
            ></v-select>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Cartões Ativos</span
                >
                <v-icon color="success" size="24">mdi-credit-card-check</v-icon>
              </div>
              <div class="d-flex align-center justify-space-between mt-2">
                <span class="text-h4 font-weight-bold">{{
                  qtdCartoesAtivos
                }}</span>
                <v-chip color="success" text-color="white" small
                  >Associados</v-chip
                >
              </div>
              <v-progress-linear
                color="success"
                :value="percentCartoesAtivos"
                height="4"
                class="mt-auto mb-1"
              ></v-progress-linear>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Cartões Inativos</span
                >
                <v-icon color="error" size="24">mdi-credit-card-off</v-icon>
              </div>
              <div class="d-flex align-center justify-space-between mt-2">
                <span class="text-h4 font-weight-bold">{{
                  qtdCartoesInativos
                }}</span>
                <v-chip color="error" text-color="white" small
                  >Não associados</v-chip
                >
              </div>
              <v-progress-linear
                color="error"
                :value="percentCartoesInativos"
                height="4"
                class="mt-auto mb-1"
              ></v-progress-linear>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Delivery</span
                >
                <v-icon color="amber darken-2" size="24"
                  >mdi-truck-delivery</v-icon
                >
              </div>
              <div class="d-flex align-center justify-space-between mt-2">
                <span class="text-h4 font-weight-bold">{{
                  deliveryCount
                }}</span>
                <v-chip color="amber darken-2" text-color="white" small
                  >Pedidos no período</v-chip
                >
              </div>
              <v-progress-linear
                color="amber darken-2"
                :value="percentDelivery"
                height="4"
                class="mt-auto mb-1"
              ></v-progress-linear>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Presencial</span
                >
                <v-icon color="primary" size="24">mdi-account-tie</v-icon>
              </div>
              <div class="d-flex align-center justify-space-between mt-2">
                <span class="text-h4 font-weight-bold">{{
                  atendenteCount
                }}</span>
                <v-chip color="primary" text-color="white" small
                  >Pedidos no período</v-chip
                >
              </div>
              <v-progress-linear
                color="primary"
                :value="percentAtendente"
                height="4"
                class="mt-auto mb-1"
              ></v-progress-linear>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Totem</span
                >
                <v-icon color="grey darken-1" size="24"
                  >mdi-tablet-dashboard</v-icon
                >
              </div>
              <div class="d-flex align-center justify-space-between mt-2">
                <span class="text-h4 font-weight-bold">{{ totemCount }}</span>
                <v-chip color="grey darken-1" text-color="white" small
                  >Pedidos no período</v-chip
                >
              </div>
              <v-progress-linear
                color="grey darken-1"
                :value="totemCount > 0 ? 100 : 0"
                height="4"
                class="mt-auto mb-1"
              ></v-progress-linear>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Saldo em Cartões</span
                >
                <v-icon color="deep-purple" size="24">mdi-wallet</v-icon>
              </div>
              <div class="mt-2">
                <span class="text-h4 font-weight-bold deep-purple--text">{{
                  saldoCartoes
                }}</span>
              </div>
              <div class="caption grey--text mt-1">
                Total disponível para compra
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Valor de Recargas</span
                >
                <v-icon color="deep-orange" size="24">mdi-cash-plus</v-icon>
              </div>
              <div class="mt-2">
                <span class="text-h4 font-weight-bold deep-orange--text">{{
                  valorRecargas
                }}</span>
              </div>
              <div class="caption grey--text mt-1">Recargas no período</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-card
          height="130px"
          class="rounded-lg dashboard-card elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-text class="pa-4">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-space-between">
                <span
                  :class="
                    isDarkMode
                      ? 'grey--text text--lighten-1'
                      : 'grey--text text--darken-1'
                  "
                  class="text-subtitle-1 font-weight-medium"
                  >Valor de Consumos</span
                >
                <v-icon color="teal" size="24">mdi-cash-minus</v-icon>
              </div>
              <div class="mt-2">
                <span class="text-h4 font-weight-bold teal--text">{{
                  valorConsumos
                }}</span>
              </div>
              <div class="caption grey--text mt-1">Consumos no período</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" xs="12" sm="12" md="4">
        <v-card
          class="rounded-lg elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-title
            class="py-2"
            :class="isDarkMode ? 'white--text' : 'primary--text'"
          >
            <v-icon left :color="isDarkMode ? 'white' : 'primary'"
              >mdi-basket</v-icon
            >
            PRODUTOS MAIS PEDIDOS
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            dense
            disable-sort
            :headers="tabelaProdutos.cabecalho"
            :items="tabelaProdutos.conteudo"
            :items-per-page="tabelaProdutos.itensPorPagina"
            :loading="tabelaProdutos.carregamento"
            loading-text="Carregando itens..."
            class="elevation-0"
            :dark="isDarkMode"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.quantidade`]="{ item }">
              <div class="d-flex align-center">
                <span class="mr-2">{{ item.quantidade }}</span>
                <v-progress-linear
                  color="primary"
                  :value="item.quantidade"
                  height="5"
                  class="flex-grow-1"
                ></v-progress-linear>
              </div>
            </template>
            <template slot="no-data">
              <v-alert
                class="mb-0"
                dense
                text
                outlined
                :value="true"
                color="warning"
                icon="mdi-information"
                >Nenhum produto para exibir</v-alert
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="4">
        <v-card
          class="rounded-lg elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-title
            class="py-2"
            :class="isDarkMode ? 'white--text' : 'primary--text'"
          >
            <v-icon left :color="isDarkMode ? 'white' : 'primary'"
              >mdi-cash-register</v-icon
            >
            MAIORES CONSUMOS
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            dense
            disable-sort
            :headers="tabelaConsumos.cabecalho"
            :items="tabelaConsumos.conteudo"
            :items-per-page="tabelaConsumos.itensPorPagina"
            :loading="tabelaConsumos.carregamento"
            loading-text="Carregando itens..."
            class="elevation-0"
            :dark="isDarkMode"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.totalConsumido`]="{ item }">
              <div class="d-flex align-center">
                <span class="mr-2">{{ item.totalConsumido }}</span>
                <v-progress-linear
                  color="primary"
                  :value="
                    parseFloat(
                      item.totalConsumido
                        .replace('R$', '')
                        .replace('.', '')
                        .replace(',', '.')
                    ) / 10
                  "
                  height="5"
                  class="flex-grow-1"
                ></v-progress-linear>
              </div>
            </template>
            <template slot="no-data">
              <v-alert
                class="mb-0"
                dense
                text
                outlined
                :value="true"
                color="warning"
                icon="mdi-information"
                >Nenhum consumo para exibir</v-alert
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="4">
        <v-card
          class="rounded-lg elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-title
            class="py-2"
            :class="isDarkMode ? 'white--text' : 'primary--text'"
          >
            <v-icon left :color="isDarkMode ? 'white' : 'primary'"
              >mdi-basket-minus</v-icon
            >
            PRODUTOS COM BAIXO ESTOQUE
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            dense
            disable-sort
            :headers="tabelaEstoqueProdutos.cabecalho"
            :items="tabelaEstoqueProdutos.conteudo"
            :items-per-page="tabelaEstoqueProdutos.itensPorPagina"
            :loading="tabelaEstoqueProdutos.carregamento"
            loading-text="Carregando itens..."
            class="elevation-0"
            :dark="isDarkMode"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.situacao`]="{ item }">
              <v-chip
                small
                :color="retornaSituacaoProduto(item).cor"
                dark
                style="width: 115px"
              >
                <v-icon
                  left
                  small
                >
                  {{ retornaSituacaoProduto(item).icone }}
                </v-icon>
                {{ retornaSituacaoProduto(item).texto }}
              </v-chip>
            </template>
            <template slot="no-data">
              <v-alert
                class="mb-0"
                dense
                text
                outlined
                :value="true"
                color="warning"
                icon="mdi-information"
                >Nenhum consumo para exibir</v-alert
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-card
          class="rounded-lg elevation-3 transition-swing"
          :dark="isDarkMode"
        >
          <v-card-title
            class="py-2"
            :class="isDarkMode ? 'white--text' : 'primary--text'"
          >
            <v-icon left :color="isDarkMode ? 'white' : 'primary'"
              >mdi-chart-line</v-icon
            >
            RECARGAS POR DIA E FORMA DE PAGAMENTO
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <apexchart
              :series="graficoFinanceiro.dados"
              :options="getChartOptions"
              height="300px"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog persistent v-model="dialogoCriaPin" max-width="400px">
      <v-card>
        <v-card-title>Criar PIN</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <p>Crie um código PIN para efetuar depositos e saques. O PIN deverá ter 04 (quatro) números.</p>
          <v-otp-input length="4" color="#474d55" type="number" v-model="pin"></v-otp-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" :disabled="pin.length < 4" @click="salvarPin">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="primary"
      :is-full-page="fullPage"
    />
    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import axios from "axios";
import { mapState } from "vuex";
// import moment from 'moment';
import Snackbar from "../componentes/snackbar.vue";

export default {
  components: {
    Snackbar,
    Loading,
  },

  data: (vm) => ({
    fullPage: true,
    isLoading: false,
    isDarkMode: false,
    mostrarFiltros: false,
    menuFiltros: false,
    dialogoCriaPin: false,
    empresas: [],
    empresaSelecionada: "",
    pin: '',
    qtdCartoesAtivos: 0,
    percentCartoesAtivos: 0,
    qtdCartoesInativos: 0,
    percentCartoesInativos: 0,
    deliveryCount: 0,
    percentDelivery: 0,
    atendenteCount: 0,
    totemCount: 0,
    percentAtendente: 0,
    saldoCartoes: "R$ 0,00",
    valorRecargas: "R$ 0,00",
    valorConsumos: "R$ 0,00",
    menu1: false,
    menu2: false,
    dateFormattedInicio: vm.formatDate(
      new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    dateFormattedFim: vm.formatDate(
      new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    dataInicio: new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    dataFim: new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    tabelaProdutos: {
      cabecalho: [
        { text: "Nome", value: "nome" },
        { text: "Quantidade", value: "quantidade" },
      ],
      carregamento: false,
      conteudo: [],
      itensPorPagina: 5,
      mensagemCarregamento: "",
    },
    tabelaConsumos: {
      cabecalho: [
        { text: "Nome", value: "nome" },
        { text: "Total consumido", value: "totalConsumido" },
      ],
      carregamento: false,
      conteudo: [],
      itensPorPagina: 5,
    },
    tabelaEstoqueProdutos: {
      cabecalho: [
        { text: "Nome", value: "nome", width: "200px" },
        { text: "Estoque", value: "estoque" },
        { text: "Mínimo", value: "estoqueMinimo" },
        { text: "Situação", value: "situacao" },
      ],
      carregamento: false,
      conteudo: [],
      itensPorPagina: 5,
    },
    graficoFinanceiro: {
      dados: [],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
            },
          },
          dropShadow: {
            enabled: true,
            top: 3,
            left: 2,
            blur: 4,
            opacity: 0.1,
          },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        colors: ["#1E88E5", "#43A047", "#FB8C00", "#E53935"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 0.7,
            stops: [0, 100],
          },
        },
        grid: {
          borderColor: "#f1f1f1",
          row: {
            colors: ["transparent", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          type: "category",
          title: {
            text: "Data",
            style: {
              fontSize: "12px",
              fontWeight: 500,
            },
          },
          labels: {
            formatter: function (value) {
              if (value) {
                const date = new Date(value);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                return `${day}/${month}`;
              }
            },
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Valor Total (R$)",
            style: {
              fontSize: "12px",
              fontWeight: 500,
            },
          },
          labels: {
            formatter: function (value) {
              return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(value);
            },
            style: {
              fontSize: "12px",
            },
          },
        },
        markers: {
          size: 4,
          colors: ["#1E88E5", "#43A047", "#FB8C00", "#E53935"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 6,
          },
        },
        tooltip: {
          theme: "light",
          y: {
            formatter: function (value) {
              return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(value);
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          floating: false,
          offsetY: 0,
          offsetX: 0,
          showForSingleSeries: true,
          markers: {
            width: 10,
            height: 10,
            strokeWidth: 0,
            strokeColor: "#fff",
            radius: 12,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5,
          },
          fontSize: "13px",
        },
      },
    },
    filtroAtivo: false,
  }),

  computed: {
    ...mapState({
      usuarioadmin: (state) => state.Userpermission,
      usuarioLogado: (state) => state.isMenuVisible,
      user: (state) => state.userObj,
      companyobj: (state) => state.companyObj,
      computedDateFormattedInicio() {
        return this.formatDate(this.dataInicio);
      },
      computedDateFormattedFim() {
        return this.formatDate(this.dataFim);
      },
    }),

    getChartOptions() {
      // Retorna as opções do gráfico com base no modo escuro
      const options = { ...this.graficoFinanceiro.options };

      if (this.isDarkMode) {
        options.theme = { mode: "dark" };
        options.grid.borderColor = "#404040";
        options.tooltip.theme = "dark";
      } else {
        options.theme = { mode: "light" };
        options.grid.borderColor = "#f1f1f1";
        options.tooltip.theme = "light";
      }

      return options;
    },
  },

  watch: {
    dataInicio() {
      this.dateFormattedInicio = this.formatDate(this.dataInicio);
    },

    dataFim() {
      this.dateFormattedFim = this.formatDate(this.dataFim);
    },

    isDarkMode: {
      handler(newVal) {
        localStorage.setItem("isDarkMode", newVal);
      },
    },
  },

  mounted() {
    // Verificar preferência de modo escuro no localStorage
    const savedDarkMode = localStorage.getItem("isDarkMode");
    if (savedDarkMode !== null) {
      this.isDarkMode = savedDarkMode === "true";
    } else {
      // Verificar preferência do sistema
      const prefersDark =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;
      this.isDarkMode = prefersDark;
    }

    // Verificar se existe um filtro salvo no localStorage
    const filtroSalvo = localStorage.getItem("filtroData");
    if (filtroSalvo) {
      const filtro = JSON.parse(filtroSalvo);
      if (filtro.ativo) {
        this.filtroAtivo = true;
        this.dataInicio = filtro.dataInicio;
        this.dataFim = filtro.dataFim;
        this.dateFormattedInicio = this.formatDate(filtro.dataInicio);
        this.dateFormattedFim = this.formatDate(filtro.dataFim);
      }
    }

    if (this.user.tipo == "ADMIN") {
      this.carregaEmpresas();
    } else {
      this.carregaDados(this.user.empresaId);
    }

    if (this.user.tipo != 'ADMIN' && !this.user.pin) {
      this.dialogoCriaPin = true
    }

    // Inicializar porcentagens para as barras de progresso
    this.percentCartoesAtivos = 0;
    this.percentCartoesInativos = 0;
    this.percentDelivery = 0;
    this.percentAtendente = 0;
  },

  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
    },

    async carregaEmpresas() {
      await axios
        .get(
          baseApiUrl +
            'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' +
            sessionStorage.getItem("accToken")
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.empresas = response.data;
          }
        });
    },

    async carregaDados(empresaId) {
      this.isLoading = true;
      this.tabelaConsumos.carregamento = true;
      this.tabelaProdutos.carregamento = true;

      let dados = {
        empresaId: empresaId,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
      };

      await axios
        .post(
          baseApiUrl +
            "ExtratoCartoes/dashboard?access_token=" +
            sessionStorage.getItem("accToken"),
          dados
        )
        .then((response) => {
          if (response.data) {
            this.qtdCartoesInativos = response.data.cartoesInativos;
            this.qtdCartoesAtivos = response.data.cartoesAtivos;

            // Calcular porcentagens para as barras de progresso
            const totalCartoes =
              this.qtdCartoesAtivos + this.qtdCartoesInativos;
            this.percentCartoesAtivos =
              totalCartoes > 0
                ? (this.qtdCartoesAtivos / totalCartoes) * 100
                : 0;
            this.percentCartoesInativos =
              totalCartoes > 0
                ? (this.qtdCartoesInativos / totalCartoes) * 100
                : 0;

            this.atendenteCount = response.data.vendasAtendente;
            this.deliveryCount = response.data.vendasDelivery;
            this.totemCount = response.data.vendasTotem;

            // Calcular porcentagens para transações
            const totalTransacoes =
              this.atendenteCount + this.deliveryCount + this.totemCount;
            this.percentDelivery =
              totalTransacoes > 0
                ? (this.deliveryCount / totalTransacoes) * 100
                : 0;
            this.percentAtendente =
              totalTransacoes > 0
                ? (this.atendenteCount / totalTransacoes) * 100
                : 0;

            this.tabelaConsumos.conteudo = response.data.maioresConsumos;
            this.tabelaProdutos.conteudo = response.data.produtosMaisVendidos;
            this.tabelaEstoqueProdutos.conteudo = response.data.produtosBaixoEstoque;
            this.graficoFinanceiro.dados = response.data.graficoFinanceiro;
            this.saldoCartoes = response.data.saldoCartoes;
            this.valorRecargas = response.data.valorRecargas;
            this.valorConsumos = response.data.valorConsumos;
          }
        })
        .catch(() => {
          this.$refs.chamaSnackbar.mostrar(
            "Erro ao carregar dados do dashboard",
            "error"
          );
        })
        .finally(() => {
          this.isLoading = false;
          this.tabelaConsumos.carregamento = false;
          this.tabelaProdutos.carregamento = false;
        });
    },

    aplicarFiltro() {
      // Marcar o filtro como ativo e carregar os dados com os parâmetros de data selecionados
      this.filtroAtivo = true;

      // Chamar a função de carregar dados com o filtro aplicado
      this.carregaDados(
        this.user.tipo == "ADMIN"
          ? this.empresaSelecionada
          : this.user.empresaId
      );

      // Salvar o estado do filtro no localStorage para persistir entre sessões
      localStorage.setItem(
        "filtroData",
        JSON.stringify({
          ativo: true,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
        })
      );
    },

    limparFiltro(event) {
      // Prevenir a propagação do evento para não abrir o menu de filtro
      if (event) {
        event.stopPropagation();
      }

      // Resetar as datas para o dia atual
      const hoje = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.dataInicio = hoje;
      this.dataFim = hoje;
      this.dateFormattedInicio = this.formatDate(hoje);
      this.dateFormattedFim = this.formatDate(hoje);

      // Marcar o filtro como inativo
      this.filtroAtivo = false;

      // Recarregar os dados com as datas resetadas
      this.carregaDados(
        this.user.tipo == "ADMIN"
          ? this.empresaSelecionada
          : this.user.empresaId
      );

      // Limpar o estado do filtro no localStorage
      localStorage.removeItem("filtroData");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    async salvarPin() {
      var vm = this;
      this.isLoading = true

      await axios.patch(baseApiUrl + 'Usuarios/' + this.user.id + '?access_token=' + sessionStorage.getItem("accToken"), { pin: this.pin })
      .then(response => {
        if (response.data) {
          this.dialogoCriaPin = false
          sessionStorage.setItem('user', JSON.stringify(response.data))
          vm.$refs.chamaSnackbar.snack("#0288D1", "PIN salvo!", "INFORMAÇÃO")
        }
      })
      .catch(() => {
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao salvar PIN", "DESCULPE")
      })

      this.isLoading = false
    },

    retornaSituacaoProduto(produto) {
      if (!produto) return

      if (produto.estoque <= 0) {
        return {
          texto: 'Sem estoque',
          cor: 'red',
          icone: 'mdi-close'
        }
      }

      if (produto.estoque <= produto.estoqueMinimo) {
        return {
          texto: 'Estoque baixo',
          cor: 'orange',
          icone: 'mdi-alert'
        }
      }

      if (produto.estoque > produto.estoqueMinimo) {
        return {
          texto: 'Em estoque',
          cor: 'green',
          icone: 'mdi-check'
        }
      }
    },
  },
};
</script>

<style>
.dashboard-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  transition: background-color 0.3s ease;
}

.dark-mode {
  background-color: #121212;
}

.dark-mode .v-card {
  background-color: #1e1e1e !important;
}

.dashboard-header {
  border-bottom: none !important;
  overflow: hidden;
}

.card-light {
  background-color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.card-dark {
  background-color: #1e1e1e !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
}

.dashboard-title h1 {
  font-size: 1.5rem;
  letter-spacing: 0.5px;
}

.filter-btn {
  height: 36px;
  border-radius: 20px !important;
  text-transform: none;
  letter-spacing: 0.3px;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.btn-active {
  font-weight: 500;
}

.filter-menu {
  border-radius: 12px !important;
}

.empresa-select {
  max-width: 250px;
}

.empresa-select .v-input__slot {
  border-radius: 20px !important;
  min-height: 36px !important;
}

.empresa-select .v-select__selections {
  padding-top: 0 !important;
}

.search-btn {
  height: 36px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 20px !important;
}

.dashboard-card {
  transition: transform 0.3s, background-color 0.3s ease;
}

.dashboard-card:hover {
  transform: translateY(-5px);
}

.v-data-table th {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  color: #424242 !important;
  background-color: #f5f5f5 !important;
}

.dark-mode .v-data-table th {
  color: #e0e0e0 !important;
  background-color: #222222 !important;
}

.v-data-table td {
  font-size: 0.875rem !important;
}

.v-data-table .v-data-table__wrapper {
  border-radius: 8px;
}

.transition-swing {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

#create .v-btn--floating {
  position: relative;
}

.v-chip--small {
  height: 20px !important;
}

/* Estilos adicionais para o modo escuro */
.dark-mode .v-progress-linear__background {
  opacity: 0.2 !important;
}

/* Estilos para o chip de filtro */
.filter-chip {
  font-weight: 500 !important;
  letter-spacing: 0.3px !important;
  border-radius: 16px !important;
  height: 24px !important;
}

.filter-tags {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .dashboard-title h1 {
    font-size: 1.25rem;
  }

  .empresa-select {
    max-width: 100%;
    margin-top: 12px;
  }

  .filter-tags {
    margin-top: 8px;
  }
}
</style>
